export default "__VITE_ASSET__CJ6ticiT__"